/*
 * @Author: your name
 * @Date: 2021-03-01 14:33:58
 * @LastEditTime: 2021-08-12 10:05:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\store\programEditing\mutation-types.js
 */
export const RATIO_COUNT = 'RATIO_COUNT'; // 缩放比例
export const VDR_LIST_ADD = 'VDR_LIST_ADD'; // 添加窗口
export const VDR_LIST_EDIT = 'VDR_LIST_EDIT'; // 修改窗口
export const VDR_LIST_DEL = 'VDR_LIST_DEL'; // 删除窗口
export const VDR_LIST_CLEAR = 'VDR_LIST_CLEAR'; // 清除全部窗口
export const VDR_INDEX = 'VDR_INDEX'; // 当前激活窗口
export const IS_SAVE_PROGRAM = 'IS_SAVE_PROGRAM'; // 设置是否开始截图
// export const VDR_CHILD_INDEX = 'VDR_CHILD_INDEX'; // 当前激活窗口子元素
export const VDR_WIN_ZINDEX = 'VDR_WIN_ZINDEX'; // 修改层级
export const VDR_WIN_CEIL = 'VDR_WIN_CEIL'; // 最上层
export const VDR_WIN_FLOOR = 'VDR_WIN_FLOOR'; // 最下层
export const VDR_WIN_FULL = 'VDR_WIN_FULL'; // 铺满方式
export const VDR_WIN_ALIGN = 'VDR_WIN_ALIGN'; // 对齐方式
export const VDR_WINDOW_SIZE = 'VDR_WINDOW_SIZE'; // 容器窗口尺寸
export const VDR_GRID_SET = 'VDR_GRID_SET'; // 设置窗口背景网格
